import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | QUESTION] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | QUESTION] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | QUESTION] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | QUESTION] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | QUESTION] Add Entity',
  UpdateEntity = '[STORE | ENTITY | QUESTION] Update Entity',
  RemoveEntity = '[STORE | ENTITY | QUESTION] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | QUESTION] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | QUESTION] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | QUESTION] Clean Up Snapshots',
  SetQuestionId = '[STORE | ENTITY | POINT_OF_INTEREST] Set Question Id',
  RearrangeQuestions = '[STORE | ENTITY | QUESTION] Rearrange Questions',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.QuestionEntityModels.QuestionEntityType> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.QuestionEntityModels.QuestionEntityType> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.QuestionEntityModels.QuestionEntityType> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Set Question Id
 */
export class SetQuestionId {
  public static readonly type = ActionTypes.SetQuestionId;
  
  public constructor(public questionId: string | null) {
  }
}

/**
 * Rearrange Questions
 */
export class RearrangeQuestions {
  public static readonly type = ActionTypes.RearrangeQuestions;

  public constructor(public questions: FlatModels.QuestionEntityModels.QuestionEntityType[] | string []) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>